export default {
  fr: {
    title: 'Urgent',
  },
  en: {
    title: 'Urgent',
  },
  'pt-br': {
    title: 'Urgente',
  },
  es: {
    title: 'Urgente',
  },
  de: {
    title: 'Dringendes',
  },
} as const
